import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
export default function Dashboard() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [stats, setStats] = useState({ total:0, pro:0, free:0, messages:0 })
  const [loading, setLoading] = useState(true)
  useEffect(() => { loadData() }, [])
  async function loadData() {
    setLoading(true)
    const { data: profiles } = await supabase.from('profiles').select('*').order('created_at', { ascending: false })
    const { count: msgCount } = await supabase.from('chat_messages').select('*', { count:'exact', head:true })
    const proCount = (profiles||[]).filter(p=>p.plan==='pro').length
    setUsers(profiles||[])
    setStats({ total:profiles?.length||0, pro:proCount, free:(profiles?.length||0)-proCount, messages:msgCount||0 })
    setLoading(false)
  }
  return (
    <div style={{display:'flex',height:'100vh'}}>
      <div className="sidebar">
        <div className="sidebar-logo">DC<small>OWNER</small></div>
        <div className="sidebar-history" style={{padding:6}}>
          <div className="sidebar-session active">Dashboard</div>
          <div className="sidebar-session" onClick={()=>navigate('/')}>← Back to Chat</div>
        </div>
        <div className="sidebar-footer">
          <div className="sidebar-user">{user?.email}</div>
          <button className="sidebar-signout" onClick={signOut}>SIGN OUT</button>
        </div>
      </div>
      <div className="dashboard">
        <div className="dash-header">
          <div className="dash-title">DASHBOARD<small>OWNER PANEL</small></div>
          <button onClick={loadData} className="code-action-btn" style={{padding:'7px 18px',fontSize:11}}>↻ REFRESH</button>
        </div>
        {loading ? <div style={{color:'var(--text2)',fontFamily:'var(--font-mono)',fontSize:12}}>Loading…</div> : (<>
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-label">Total Users</div><div className="stat-value">{stats.total}</div></div>
            <div className="stat-card"><div className="stat-label">Pro Users</div><div className="stat-value fire">{stats.pro}</div></div>
            <div className="stat-card"><div className="stat-label">Free Users</div><div className="stat-value">{stats.free}</div></div>
            <div className="stat-card"><div className="stat-label">Messages</div><div className="stat-value gold">{stats.messages.toLocaleString()}</div></div>
          </div>
          <div className="stat-card" style={{marginBottom:20,background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--r2)',padding:'16px 20px'}}>
            <div className="stat-label" style={{marginBottom:6}}>Monthly Revenue (Est.)</div>
            <div className="stat-value green">${(stats.pro*19.99).toFixed(2)}</div>
          </div>
          <div className="users-table">
            <div className="users-table-header"><span className="users-table-title">All Users</span><span style={{fontFamily:'var(--font-mono)',fontSize:10,color:'var(--text2)'}}>{stats.total} total</span></div>
            <table><thead><tr><th>Email</th><th>Plan</th><th>Joined</th><th>Stripe ID</th></tr></thead>
              <tbody>{users.map(u=>(
                <tr key={u.id}>
                  <td>{u.email||'—'}</td>
                  <td><span className={`badge ${u.plan==='pro'?'pro':'free'}`}>{u.plan==='pro'?'PRO':'FREE'}</span></td>
                  <td style={{color:'var(--text2)'}}>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td style={{color:'var(--text2)',fontSize:10}}>{u.stripe_customer_id?u.stripe_customer_id.slice(0,18)+'…':'—'}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </>)}
      </div>
    </div>
  )
}
